var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.vjsStyle)},[_c('video',{staticClass:"vjs-wfs video-js vjs-default-skin",attrs:{"id":"vid1","poster":_vm.poster,"controls":"","autoplay":_vm.autoplay,"width":_vm.widthStyle,"height":_vm.heightStyle}})])}
var staticRenderFns = []

export { render, staticRenderFns }